import React from 'react'
import './Contact.css';
import FooterLink from '../FooterLink/FooterLink';
import Header from '../Header/Header';
import contactVector from '../../assets/contact_anime.png';
import github from '../../assets/gh.png';
import linkedin from '../../assets/li.png';
import instagram from '../../assets/in.png';
import web from '../../assets/web.png';
const Contact = () => {
    return (
        <div className='section-container'>
            <Header
                heading='Get in touch'
                details='Interested to collaborate? Feel free to drop me an email.'
            />

            <a href="mailto:vishwakarmaabhishek31@gmail.com">
                vishwakarmaabhishek31@gmail.com
            </a>

            {/* Social icons */}
            <div className='social-icons-container'>
                <a href='https://github.com/Abhishek765' className='social-icon'>
                    <img src={github} alt='social' />
                </a>
                <a
                    href='https://linkedin.com/in/abhishek-vishwakarma17'
                    className='social-icon'
                >
                    <img src={linkedin} alt='social' />
                </a>
                <a
                    href='https://instagram.com/abhivishu10'
                    className='social-icon'
                >
                    <img src={instagram} alt='social' />
                </a>

                <a href='https://Abhishek765.github.io/portfolio/' className='social-icon'>
                    <img src={web} alt='social' />
                </a>
            </div>


            <FooterLink
                phrase='Read more '
                toAddress='/about'
                link='about me.'
            />

            <div className='vector-frame'>
                <img
                    src={contactVector}
                    alt='vector'
                    className='about-vector'
                />
            </div>
        </div>
    )
}

export default Contact
